import type { Contact } from '../../../domain/contact';
import type { AppState } from '../../../services/appStore';
import { CONTACT_KEY } from '../repository';

const makeContactQueryKeyFromState = ({ contactLinkedinId, collectedContactInfo }: AppState) => {
  const companyIds = collectedContactInfo?.numericCompanyLinkedinIds || [];
  let companyNames: string[] = [];
  if (Array.isArray(collectedContactInfo?.companyName)) {
    companyNames = collectedContactInfo?.companyName as string[];
  } else {
    companyNames = [collectedContactInfo?.companyName || ''];
  }
  return [
    CONTACT_KEY,
    contactLinkedinId,
    collectedContactInfo?.name?.toLowerCase(),
    ...companyNames.map((name) => name.toLowerCase()),
    ...companyIds,
  ];
};

const makeContactQueryKeyFromData = (contact: Contact) => {
  const { linkedinId, linkedinSalesNavId, name, companyName, numericCompanyLinkedinIds = [] } = contact;

  return [
    CONTACT_KEY,
    linkedinId ?? linkedinSalesNavId,
    name.toLowerCase(),
    companyName?.toLowerCase(),
    ...numericCompanyLinkedinIds,
  ];
};

const makeContactQueryKeyFromLinkedinId = (linkedinId: string) => {
  return [CONTACT_KEY, linkedinId];
};

const linkedinContactQueryKey = {
  fromState: makeContactQueryKeyFromState,
  fromData: makeContactQueryKeyFromData,
  fromLinkedinId: makeContactQueryKeyFromLinkedinId,
};

export default linkedinContactQueryKey;
